import React from 'react'
import PropTypes from 'prop-types'

import Modal from 'component/Modal/index'
import Button from 'component/Button/index'
import Form from 'component/utils/Form'
import HierarchySelect from 'component/hierarchy/HierarchySelectNew'
import HierarchySubtypeSelect from 'component/hierarchy/HierarchySubtypeSelectNew'

const ALL = 'all'

const FIELDS = ['sectionList', 'subtypeList']

class FormModal extends React.Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    setValueToField: PropTypes.func.isRequired,
    values: PropTypes.any.isRequired,
    fields: PropTypes.any.isRequired,
    user: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
  }

  handleSubmit = () => {
    const { values, onSubmit, setValueToField } = this.props
    const { subtypeList } = values

    const sectionIdList = [values.sectionList.value]

    const subtypeIdList = subtypeList.reduce((acc, each) => {
      if (each.value !== ALL) {
        return [...acc, each]
      }

      return [...acc]
    }, [])

    const params = {
      sectionIdList,
      subtypeList: subtypeIdList,
    }

    onSubmit(params, () => {
      setValueToField('sectionList', null)
      setValueToField('subtypeList', [])
    })
  }

  handleChange = (field, values, remove) => {
    const { setValueToField } = this.props

    const formattedValues = values || []

    setValueToField(field, formattedValues)

    remove.forEach((item) => setValueToField(item, []))
  }

  checkDisabled = () => {
    const { values } = this.props
    if (values.sectionList && values.subtypeList.length) {
      return false
    }
    return true
  }

  render() {
    const { translate, values, user } = this.props

    return (
      <Modal
        title={translate('label.exclusion.subtype.new')}
        confirmButtonText={translate('register_button')}
        buttonText={translate('buttom.exclusion.subtype.new')}
        overflow='visible'
        onConfirm={this.handleSubmit}
        cancleButtonText={translate('close')}
        isConfirmButtonDisabled={this.checkDisabled()}
        disabledBgClickClosing
        renderButton={({ onClick, buttonText }) => (
          <Button
            className='btn btn-primary margin-right'
            text={buttonText}
            onClick={onClick}
          />
        )}
      >
        <>
          <div className='w-100 margin-top'>
            <HierarchySelect
              label={translate('section')}
              id='sectionList'
              name='sectionList'
              onChange={(values) =>
                this.handleChange('sectionList', values, ['subtypeList'])
              }
              placeholder='select.section'
              query={{ level: 2 }}
              selected
              translate={translate}
              user={user}
              value={values.sectionList}
              required
              fill
            />
          </div>

          <div className='w-100'>
            <HierarchySubtypeSelect
              label={translate('subType')}
              id='subtypeList'
              field='subtypeList'
              name='subtypeList'
              disabled={!values.sectionList}
              noOptions={!values.sectionList}
              onChange={(values) =>
                this.handleChange('subtypeList', values, [])
              }
              placeholder='select.subtype'
              query={{ sectionIdList: values.sectionList }}
              translate={translate}
              user={user}
              value={values.subtypeList}
              allOption
              isMulti
              required
              fill
            />
          </div>
        </>
      </Modal>
    )
  }
}

export default Form({ fields: FIELDS })(FormModal)
export { FormModal }
